export const isServerSide = () => typeof window === 'undefined';
export const isReactNative = () => {
    return (typeof document === 'undefined' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative');
};
export const isNode = () => {
    if (typeof window === 'undefined') {
        return true;
    }
    return (typeof process !== 'undefined' &&
        typeof process.versions !== 'undefined' &&
        typeof process.versions.node !== 'undefined');
};
export const isBrowser = () => {
    if (isReactNative()) {
        return false;
    }
    if (isNode()) {
        return false;
    }
    return typeof window !== 'undefined';
};
export const objectToJson = (object, params) => {
    const { replacer, indentation } = params || { replacer: null, indentation: 2 };
    return JSON.stringify(object, replacer, indentation);
};
export const protoObjectToJson = (object, params) => {
    const { replacer, indentation } = params || { replacer: null, indentation: 2 };
    if (object.toObject !== undefined) {
        return JSON.stringify(object.toObject(), replacer, indentation);
    }
    return objectToJson(object, { replacer, indentation });
};
export const grpcCoinToUiCoin = (coin) => ({
    amount: coin.amount,
    denom: coin.denom,
});
export const uint8ArrayToString = (string) => {
    if (!string) {
        return '';
    }
    if (string.constructor !== Uint8Array) {
        return string;
    }
    return new TextDecoder().decode(string);
};
export const sortObjectByKeysWithReduce = (obj) => {
    if (typeof obj !== 'object' || obj === null)
        return obj;
    if (Array.isArray(obj)) {
        return obj.map((e) => sortObjectByKeysWithReduce(e)).sort();
    }
    return Object.keys(obj)
        .sort()
        .reduce((sorted, k) => {
        const key = k;
        sorted[key] = sortObjectByKeysWithReduce(obj[key]);
        return sorted;
    }, {});
};
export const sortObjectByKeys = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortObjectByKeys);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    sortedKeys.forEach((key) => {
        result[key] = sortObjectByKeys(obj[key]);
    });
    return result;
};
export const getErrorMessage = (error, endpoint) => {
    if (!error.response) {
        return `The request to ${endpoint} has failed.`;
    }
    return error.response.data
        ? error.response.data.message || error.response.data
        : error.response.statusText;
};
/**
 * Converts value to it's number representation
 */
export const hexToNumber = (value) => {
    const [negative, hexValue] = value.startsWith('-')
        ? [true, value.slice(1)]
        : [false, value];
    const num = BigInt(hexValue);
    if (num > Number.MAX_SAFE_INTEGER) {
        return Number(negative ? -num : num);
    }
    if (num < Number.MIN_SAFE_INTEGER) {
        return Number(num);
    }
    return negative ? -1 * Number(num) : Number(num);
};
export function isJsonString(str) {
    if (typeof str !== 'string') {
        return false;
    }
    try {
        JSON.parse(str);
    }
    catch {
        return false;
    }
    return true;
}
